function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.625 4C9.20312 4 4 9.20312 4 15.625C4 22.0469 9.20312 27.25 15.625 27.25C22.0469 27.25 27.25 22.0469 27.25 15.625C27.25 9.20312 22.0469 4 15.625 4ZM19.375 11.875C20.1719 11.875 20.875 12.5781 20.875 13.375C20.875 14.2188 20.1719 14.875 19.375 14.875C18.5312 14.875 17.875 14.2188 17.875 13.375C17.875 12.5781 18.5312 11.875 19.375 11.875ZM11.875 11.875C12.6719 11.875 13.375 12.5781 13.375 13.375C13.375 14.2188 12.6719 14.875 11.875 14.875C11.0312 14.875 10.375 14.2188 10.375 13.375C10.375 12.5781 11.0312 11.875 11.875 11.875ZM20.9688 19.8906C19.6562 21.4844 17.6875 22.375 15.625 22.375C13.5156 22.375 11.5469 21.4844 10.2344 19.8906C9.57812 19.0938 10.75 18.1562 11.3594 18.9062C12.4375 20.1719 13.9844 20.875 15.625 20.875C17.2656 20.875 18.7656 20.1719 19.8438 18.9062C20.4531 18.1562 21.625 19.0938 20.9688 19.8906Z",
  fill: "#D5D7DE"
});

var SvgEmoji = function SvgEmoji(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEmoji, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/emoji.5e90e57d.svg";
export { ForwardRef as ReactComponent };